module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('g', {
    class: _vm.data,
    attrs: {
      "id": "boy1"
    }
  }, [_c('rect', {
    attrs: {
      "id": "boy1_bag_3",
      "fill": "#6D8C4A",
      "transform": "translate(3346.500000, 303.500000) scale(-1, 1) translate(-3346.500000, -303.500000) ",
      "x": "3311",
      "y": "253",
      "width": "71",
      "height": "101",
      "rx": "33"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "boy1_right_arm"
    }
  }, [_c('path', {
    attrs: {
      "d": "M3385.87656,362.490505 C3385.85956,364.81154 3384.36885,365.473323 3382.75259,368.212132 C3380.86681,371.407646 3381.08978,377.133322 3379,381.975103 C3379.60438,383.087259 3383.20761,380.989257 3383.94059,379.043899 C3384.67356,377.098541 3385.22929,375.517752 3385.48372,375.025604 C3385.73815,374.533456 3386.37204,374.567251 3386.56599,375.031941 C3386.75993,375.49663 3387.25745,392.393155 3387.65572,393.221147 C3388.05398,394.049139 3390.2576,394.078569 3390.63739,393.221147 C3391.01717,392.363725 3390.9656,378.995036 3391.1516,378.637225 C3391.3376,378.279415 3391.82198,378.451631 3392.02646,378.637225 C3392.23095,378.82282 3391.87825,393.103707 3392.20728,393.635143 C3392.5363,394.166578 3394.81208,394.074485 3395.05824,393.635143 C3395.30441,393.1958 3395.38889,378.960396 3395.63635,378.637225 C3395.88381,378.314055 3396.38521,378.350245 3396.59035,378.637225 C3396.79548,378.924206 3396.2357,392.632259 3396.59035,393.221147 C3396.945,393.810035 3399.15153,393.819329 3399.35456,393.221147 C3399.55759,392.622965 3400.00807,378.837464 3400.2218,378.637225 C3400.43553,378.436987 3400.72304,378.455715 3400.92672,378.637225 C3401.1304,378.818736 3401.34591,389.114983 3401.69796,389.674582 C3402.05002,390.23418 3403.71996,390.366406 3403.96612,389.674582 C3404.21228,388.982758 3403.0352,363.883413 3403.06798,362.490505 C3403.1772,357.848545 3400.28885,353 3394.49389,353 C3388.69892,353 3385.91308,357.506275 3385.87656,362.490505 Z",
      "id": "boy1_right_hand",
      "fill": "#AFD485",
      "transform": "translate(3391.500000, 373.500000) scale(-1, 1) rotate(6.000000) translate(-3391.500000, -373.500000) "
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "boy1_right_arm_bottom",
      "fill": "#AFD485",
      "transform": "translate(3385.500000, 345.000000) scale(-1, 1) rotate(6.000000) translate(-3385.500000, -345.000000) ",
      "x": "3377",
      "y": "319",
      "width": "17",
      "height": "52",
      "rx": "8.5"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "boy1_right_arm_top",
      "fill": "#AFD485",
      "transform": "translate(3380.500000, 298.000000) scale(-1, 1) rotate(6.000000) translate(-3380.500000, -298.000000) ",
      "x": "3372",
      "y": "259",
      "width": "17",
      "height": "78",
      "rx": "8.5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3379.5,259 L3379.5,259 L3379.5,259 C3385.57084,259 3390.55108,263.80814 3390.76449,269.875232 L3392,305 L3367,305 L3368.23551,269.875232 L3368.23551,269.875232 C3368.44892,263.80814 3373.42916,259 3379.5,259 Z",
      "id": "boy1_right_sleeve",
      "fill": "#CDF1A5",
      "transform": "translate(3379.500000, 282.000000) scale(-1, 1) rotate(6.000000) translate(-3379.500000, -282.000000) "
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3381.7938,491 C3378.4823,492.517028 3369.08417,496.007345 3366.82831,496.912489 C3364.57245,497.817634 3361.72989,501.885 3363.61526,505 C3365.50084,505 3399.20172,505 3402.04133,505 C3403.31956,504.825088 3403.31956,500.158422 3402.04133,491 C3390.81903,491 3384.06985,491 3381.7938,491 Z",
      "id": "boy1_right_shoe",
      "fill": "#94B96B",
      "transform": "translate(3383.000000, 498.000000) scale(-1, 1) translate(-3383.000000, -498.000000) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3374,407 L3374,407 L3374,407 C3380.62742,407 3386,412.372583 3386,419 L3386,491 L3362,491 L3362,419 L3362,419 C3362,412.372583 3367.37258,407 3374,407 Z",
      "id": "boy1_right_leg_bottom",
      "fill": "#6D8C4A",
      "transform": "translate(3374.000000, 449.000000) scale(-1, 1) translate(-3374.000000, -449.000000) "
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "boy1_right_leg_top",
      "fill": "#6D8C4A",
      "transform": "translate(3374.000000, 383.500000) scale(-1, 1) translate(-3374.000000, -383.500000) ",
      "x": "3362",
      "y": "336",
      "width": "24",
      "height": "95",
      "rx": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3349.7938,491 C3346.4823,492.517028 3337.08417,496.007345 3334.82831,496.912489 C3332.57245,497.817634 3329.72989,501.885 3331.61526,505 C3333.50084,505 3367.20172,505 3370.04133,505 C3371.31956,504.825088 3371.31956,500.158422 3370.04133,491 C3358.81903,491 3352.06985,491 3349.7938,491 Z",
      "id": "boy1_left_shoe",
      "fill": "#94B96B",
      "transform": "translate(3351.000000, 498.000000) scale(-1, 1) translate(-3351.000000, -498.000000) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3342,407 L3342,407 L3342,407 C3348.62742,407 3354,412.372583 3354,419 L3354,491 L3330,491 L3330,419 L3330,419 C3330,412.372583 3335.37258,407 3342,407 Z",
      "id": "boy1_left_leg_bottom",
      "fill": "#6D8C4A",
      "transform": "translate(3342.000000, 449.000000) scale(-1, 1) translate(-3342.000000, -449.000000) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3342,336 L3342,336 L3342,336 C3348.62742,336 3354,341.372583 3354,348 L3354,419 L3354,419 C3354,425.627417 3348.62742,431 3342,431 L3342,431 L3342,431 C3335.37258,431 3330,425.627417 3330,419 L3330,348 L3330,348 C3330,341.372583 3335.37258,336 3342,336 Z",
      "id": "boy1_left_leg_top",
      "fill": "#6D8C4A",
      "transform": "translate(3342.000000, 383.500000) scale(-1, 1) translate(-3342.000000, -383.500000) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3330,336 L3386,336 L3386,340 L3386,340 C3386,355.463973 3373.46397,368 3358,368 L3358,368 L3358,368 C3342.53603,368 3330,355.463973 3330,340 L3330,336 Z",
      "id": "boy1_hip",
      "fill": "#6D8C4A",
      "transform": "translate(3358.000000, 352.000000) scale(-1, 1) translate(-3358.000000, -352.000000) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3329.73802,266.805573 C3335.60408,250.707947 3373.92247,251.425762 3378.93256,266.805573 C3385.76566,287.781641 3391.93477,354.770742 3390.88228,356.460417 C3381.52245,371.486809 3328.55256,366.076736 3321.65061,358.473983 C3318.6952,355.218491 3326.58672,275.45338 3329.73802,266.805573 Z",
      "id": "boy1_torso",
      "fill": "#CDF1A5",
      "transform": "translate(3356.000000, 310.500000) scale(-1, 1) translate(-3356.000000, -310.500000) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3343.06804,257 C3345.68706,257 3351.4771,259.89702 3352,262.33649 C3350.26497,281.906387 3347.60351,318.414681 3347.39928,322 C3338.49111,316.748856 3326.94915,283.011933 3343.06804,257 Z",
      "id": "boy1_bag_2",
      "fill": "#6D8C4A",
      "transform": "translate(3343.500000, 289.500000) scale(-1, 1) translate(-3343.500000, -289.500000) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3379.71255,267.993486 C3380.94678,263.625037 3385.28851,258.516304 3389,258 C3384.20716,276.372335 3377.62005,303.167469 3374,320 C3374.7228,305.931911 3378.04576,273.892969 3379.71255,267.993486 Z",
      "id": "boy1_bag_1",
      "fill": "#6D8C4A",
      "transform": "translate(3381.500000, 289.000000) scale(-1, 1) translate(-3381.500000, -289.000000) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3327.87656,364.490505 C3327.85956,366.81154 3326.36885,367.473323 3324.75259,370.212132 C3322.86681,373.407646 3323.08978,379.133322 3321,383.975103 C3321.60438,385.087259 3325.20761,382.989257 3325.94059,381.043899 C3326.67356,379.098541 3327.22929,377.517752 3327.48372,377.025604 C3327.73815,376.533456 3328.37204,376.567251 3328.56599,377.031941 C3328.75993,377.49663 3329.25745,394.393155 3329.65572,395.221147 C3330.05398,396.049139 3332.2576,396.078569 3332.63739,395.221147 C3333.01717,394.363725 3332.9656,380.995036 3333.1516,380.637225 C3333.3376,380.279415 3333.82198,380.451631 3334.02646,380.637225 C3334.23095,380.82282 3333.87825,395.103707 3334.20728,395.635143 C3334.5363,396.166578 3336.81208,396.074485 3337.05824,395.635143 C3337.30441,395.1958 3337.38889,380.960396 3337.63635,380.637225 C3337.88381,380.314055 3338.38521,380.350245 3338.59035,380.637225 C3338.79548,380.924206 3338.2357,394.632259 3338.59035,395.221147 C3338.945,395.810035 3341.15153,395.819329 3341.35456,395.221147 C3341.55759,394.622965 3342.00807,380.837464 3342.2218,380.637225 C3342.43553,380.436987 3342.72304,380.455715 3342.92672,380.637225 C3343.1304,380.818736 3343.34591,391.114983 3343.69796,391.674582 C3344.05002,392.23418 3345.71996,392.366406 3345.96612,391.674582 C3346.21228,390.982758 3345.0352,365.883413 3345.06798,364.490505 C3345.1772,359.848545 3342.28885,355 3336.49389,355 C3330.69892,355 3327.91308,359.506275 3327.87656,364.490505 Z",
      "id": "boy1_left_hand",
      "fill": "#AFD485",
      "transform": "translate(3333.500000, 375.500000) scale(-1, 1) translate(-3333.500000, -375.500000) "
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "boy1_left_arm_bottom",
      "fill": "#AFD485",
      "transform": "translate(3330.500000, 346.000000) scale(-1, 1) translate(-3330.500000, -346.000000) ",
      "x": "3322",
      "y": "320",
      "width": "17",
      "height": "52",
      "rx": "8.5"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "boy1_left_arm_top",
      "fill": "#AFD485",
      "transform": "translate(3330.500000, 299.000000) scale(-1, 1) translate(-3330.500000, -299.000000) ",
      "x": "3322",
      "y": "260",
      "width": "17",
      "height": "78",
      "rx": "8.5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3330.5,260 L3330.5,260 L3330.5,260 C3336.57084,260 3341.55108,264.80814 3341.76449,270.875232 L3343,306 L3318,306 L3319.23551,270.875232 L3319.23551,270.875232 C3319.44892,264.80814 3324.42916,260 3330.5,260 Z",
      "id": "boy1_left_sleeve",
      "fill": "#CDF1A5",
      "transform": "translate(3330.500000, 283.000000) scale(-1, 1) translate(-3330.500000, -283.000000) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3351.96658,250.4535 C3352.62547,254.580108 3352.88319,256.226482 3351,258.496304 C3351.32154,259.076829 3353.38318,261.244728 3357.18491,265 C3363.30545,261.550719 3366.91048,259.382821 3368,258.496304 C3366.29459,256.171031 3366.38952,255.064283 3367.40203,250.4535 C3366.14384,247.12671 3353.72348,247.238098 3351.96658,250.4535 Z",
      "id": "boy1_neck",
      "fill": "#AFD485",
      "transform": "translate(3359.500000, 256.500000) scale(-1, 1) translate(-3359.500000, -256.500000) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3378.1205,221.963228 C3379.79581,220.957869 3382.2009,219.680702 3384.92775,221.963228 C3387.26019,223.915602 3385.5069,231.574975 3382.36054,235.816712 C3379.244,240.018248 3374.17435,240.890568 3372.18445,239.280084 C3367.98623,248.935837 3357.28676,254.06325 3350.13625,253.999411 C3330.99283,253.828501 3323,234.057079 3323,217.634014 C3323,191.729591 3333.14698,183.000645 3350.13625,183.000645 C3365.38515,182.91599 3382.31085,191.138717 3378.1205,221.963228 Z",
      "id": "boy1_face",
      "fill": "#AFD485",
      "fill-rule": "nonzero",
      "transform": "translate(3354.500000, 218.500000) scale(-1, 1) translate(-3354.500000, -218.500000) "
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "boy1_mouth_bottom"
    }
  }, [_c('path', {
    attrs: {
      "d": "M3355.32575,247 C3356.47905,247 3366.49181,247 3367.78027,247 C3369.06873,247 3364.44625,245 3360.29344,245 C3356.14062,245 3354.17245,247 3355.32575,247 Z",
      "fill": "#94B96B",
      "transform": "translate(3361.500000, 246.000000) scale(-1, -1) translate(-3361.500000, -246.000000) "
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3354.40093,244 C3355.82037,244 3368.14376,244 3369.72956,244 C3371.31536,244 3365.62615,241 3360.515,241 C3355.40384,241 3352.98148,244 3354.40093,244 Z",
      "id": "boy1_mouth_top",
      "fill": "#94B96B",
      "transform": "translate(3362.000000, 242.500000) scale(-1, 1) translate(-3362.000000, -242.500000) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3361.92737,221.278291 C3361.92737,219.646167 3366.36275,219.503139 3366.36493,221.278291 C3366.36711,223.053443 3367.7913,232.316183 3366.36711,233.962135 C3364.94292,235.608088 3360.75635,235.056616 3360.10845,233.962135 C3359.46054,232.867654 3361.92737,222.910415 3361.92737,221.278291 Z",
      "id": "boy1_nose",
      "fill": "#94B96B",
      "transform": "translate(3363.500000, 227.500000) scale(-1, 1) translate(-3363.500000, -227.500000) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3382,222.475587 C3379.71082,217.227013 3369.52997,216.425993 3368,220.971022 C3367.99274,227.108262 3380.33588,227.650327 3382,222.475587 Z",
      "id": "boy1_right_eye_whites",
      "fill": "#CDF1A5",
      "transform": "translate(3375.000000, 222.000000) scale(-1, 1) translate(-3375.000000, -222.000000) "
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "boy1_right_pupil",
      "fill": "#6D8C4A",
      "transform": "translate(3377.500000, 222.500000) scale(-1, 1) translate(-3377.500000, -222.500000) ",
      "cx": "3377.5",
      "cy": "222.5",
      "r": "3.5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3340,222.475587 C3342.28918,217.227013 3352.47003,216.425993 3354,220.971022 C3354.00726,227.108262 3341.66412,227.650327 3340,222.475587 Z",
      "id": "boy1_left_eye_whites",
      "fill": "#CDF1A5",
      "transform": "translate(3347.000000, 222.000000) scale(-1, 1) translate(-3347.000000, -222.000000) "
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "boy1_left_pupil",
      "fill": "#6D8C4A",
      "transform": "translate(3349.500000, 222.500000) scale(-1, 1) translate(-3349.500000, -222.500000) ",
      "cx": "3349.5",
      "cy": "222.5",
      "r": "3.5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3381.97287,214.573047 C3381.55258,212.535821 3368.28392,212.503758 3368.01765,214.323628 C3367.75137,216.143499 3370.53028,215.275769 3374.18763,215.623966 C3377.84498,215.972164 3382.39317,216.610274 3381.97287,214.573047 Z",
      "id": "boy1_right_brow",
      "fill": "#94B96B",
      "transform": "translate(3375.000000, 214.500000) scale(-1, 1) translate(-3375.000000, -214.500000) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3340.02713,214.573047 C3340.44742,212.535821 3353.71608,212.503758 3353.98235,214.323628 C3354.24863,216.143499 3351.46972,215.275769 3347.81237,215.623966 C3344.15502,215.972164 3339.60683,216.610274 3340.02713,214.573047 Z",
      "id": "boy1_left_brow",
      "fill": "#94B96B",
      "transform": "translate(3347.000000, 214.500000) scale(-1, 1) translate(-3347.000000, -214.500000) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3324,198.300876 C3327.33887,195.050859 3363.99365,195.301041 3366.86973,198.300876 C3369.7458,201.300712 3371.21538,224.52027 3370.88751,228.155936 C3370.55964,231.791602 3374.46605,232.033953 3375.39418,228.348075 C3376.3223,224.662196 3376.74363,223.357256 3377.01348,221.571723 C3378.15314,220.477128 3380.84718,219.779045 3382.32269,220.392168 C3383.773,199.647709 3385.99708,180 3352.1568,180 C3328.9977,180 3325.64033,194.238844 3324,198.300876 Z",
      "id": "boy1_hair",
      "fill": "#94B96B",
      "transform": "translate(3353.500000, 205.500000) scale(-1, 1) translate(-3353.500000, -205.500000) "
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54740b2a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/module_3/svg/background/boy1.vue
// module id = 700
// module chunks = 1